module.exports = __webpack_public_path__ + "static/media/bry-r.eee7270f.mp3";